import {
  dateToCalendarDateTime,
  getCurrentCalendarDateTime,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/durationInputs/initialDurationValues";
import { TrainRouteStop } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";

const plusHours = (date: Date | null, hours: number) => {
  if (!date) return null;
  const newDate = new Date(date);
  newDate.setHours(newDate.getHours() + hours);
  return dateToCalendarDateTime(newDate);
};

const defaultVisibility = () => getCurrentCalendarDateTime(10);

// There is a similiar function in drops-backend in TrainInformationServiceImpl.kt
export const getVisibilityEndTime = (stops: TrainRouteStop[]) =>
  plusHours(stops[stops.length - 1]?.estimatedArrivalTime, 1) ??
  plusHours(stops[stops.length - 1]?.scheduledArrivalTime, 1) ??
  defaultVisibility();
